import axios from "axios";

const server = "https://app-api.pakraillive.com/api";
export const baseUrl = " https://app-api.pakraillive.com/api";

const instance = axios.create({
  baseURL: server,
  // withCredentials:true
});

instance.interceptors.request.use((request) => {
  const storedUser = localStorage.getItem("user");
  let token = localStorage.getItem("token");
  if (!token && storedUser) {
    try {
      const parsedUser = JSON.parse(storedUser);
      token = parsedUser?.Token || parsedUser?.token || "";
    } catch (e) {
      token = "";
    }
  }
  request.headers = {
    Accept: "application/json, text/plain, */*",
    Authorization: `Bearer ${token}`,
    "App-API-Key":
      process.env.REACT_APP_APP_API_KEY || "6f48b484-5e12-4b2c-9f37-09788e6a159d",
    "X-PakRail-Client":
      process.env.REACT_APP_CLIENT_ID || "locomotive-dashboard",
    "X-PakRail-Client-Key":
      process.env.REACT_APP_CLIENT_KEY ||
      "ld-a8f3c91e-6b24-4d7e-9c10-2e5f8a7b4d63",
  };

  return request;
});

instance.interceptors.response.use((response) => {
  if (response) {
    return response;
  }
}, function (error) {
  return Promise.reject(error)
})

export default instance;